import { Env } from "./lib/EnvironmentVariables";

const cognitoConfig = {
  region: Env.Cognito.Region,
  userPoolId: Env.Cognito.UserPoolId,
  userPoolWebClientId: Env.Cognito.UserPoolWebClientId,
};

export default cognitoConfig;
